import { theme } from '@hiver/hiver-ui-kit'

export default {
    ckDefaultDiv: {
        display: "block",
        marginRight: "26px",
        height: "100%",
        fontFamily: 'Open Sans',
        color: theme.palette.gray.black,
    }
    
}; 
